import { React } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

export default function SubscribeSelectBox(props) {
  const { isUsePaymentSystem, isUseSubscribe, setIsUseSubscribe } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  // 정기구독권 일반권 선택시 //
  function onClickSelectBox(value) {
    if (!isUsePaymentSystem) {
      alert(t('settingMembership.paymentSystemRequired'));
      return;
    }

    setIsUseSubscribe(value);
  }

  return (
    <TopLevelWrapper>
      <ExplanationWrapper>
        <Explanation>{t('settingMembership.subscriptionType')}</Explanation>
      </ExplanationWrapper>
      <BoxWrapper>
        <SelectBox isClicked={isUseSubscribe === 0} onClick={() => onClickSelectBox(0)}>
          <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={isUseSubscribe === 0 ? theme.white : theme.text} cursor='pointer'>{t('settingMembership.regularPass')}</Text>
        </SelectBox>
        <SelectBox isClicked={isUseSubscribe === 1} onClick={() => onClickSelectBox(1)}>
          <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={isUseSubscribe === 1 ? theme.white : theme.text} cursor='pointer'>{t('settingMembership.subscription')}</Text>
        </SelectBox>
      </BoxWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  
  transition: all 0.3s ease-in-out;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;

  &:hover {
    cursor: default;
  }
`;

const BoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;
  
  margin-top: 8px;
  gap: 8px;

  width: 100%;
`;

const SelectBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 112px;
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
